import styled from "styled-components";
import { MENU_COLORS } from "@lhd/constants";

export const Styles = styled.div<{ isLabelBold?: boolean }>`
  .ant-form-item-label {
    label {
      font-weight: ${({ isLabelBold }) => (isLabelBold ? 700 : "inherit")};
      font-size: ${({ isLabelBold }) => (isLabelBold ? "16px" : "inherit")};
    }
  }
  .ant-input-number {
    border: 0;
  }
  .required-field {
    .ant-input {
      background: #ffe8e8;
    }
    .ant-input-status-error {
      background: #ffd6d6 !important;
    }
  }

  .ant-input-number-affix-wrapper {
    .ant-input-number {
      padding: 0;
    }
  }

  &.text-area {
    .ant-form-item-control-input {
      height: auto;
    }
  }

  .text-area__count {
    text-align: right;
    font-size: 14px;
    line-height: 22px;
    color: #00000040;
    font-weight: 400;
  }

  .ant-input-number,
  .ant-input-number-affix-wrapper {
    border: 1px solid #cfd0d0;
    border-radius: 0;
    width: 100%;
    padding: 10px 20px;
    font-size: 13px;
    color: #2e2e33;

    input {
      border-radius: 0;
    }

    .ant-input-number-handler {
      display: none;
    }

    .ant-input-number-input {
      height: auto;
    }

    input {
      border: none;
      padding: 0;
    }
  }

  .ant-form-item-control-input {
    height: 40px;
  }

  .ant-form-item-explain-error {
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 5px;
    font-size: 12px;
  }

  input,
  .ant-input-affix-wrapper,
  .ant-picker {
    border: 1px solid #cfd0d0;
    border-radius: 0;
    width: 100%;
    padding: 10px 20px;
    font-size: 13px;
    color: #2e2e33;
  }

  input {
    text-overflow: ellipsis;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }

  .ant-input-affix-wrapper,
  .ant-picker {
    input {
      border-radius: 0;
    }
  }

  .ant-picker {
    input {
      border: 0;
      padding: 0;
    }
  }

  .ant-picker-focused,
  .ant-picker:hover {
    border-color: #40a9ff;
  }

  &.select {
    .ant-form-item-control-input {
      min-height: 40px;
      height: auto;
    }
  }

  .ant-select {
    min-height: 40px;
  }

  .ant-select-multiple {
    .ant-select-selector {
      min-height: 43px;
      padding: 4px 20px;

      .ant-select-selection-overflow {
        flex-wrap: wrap;
        /* overflow-x: scroll; */
      }
    }
  }

  .ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search-input {
    height: 40px;
    padding-left: 10px;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid #cfd0d0;
    border-radius: 0 !important;
    width: 100% !important;
    color: #2e2e33;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: #40a9ff;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 5.2px 20px;
    height: 100%;
  }

  .ant-select-item-option-content,
  .ant-select-selection-item {
    font-size: 13px;
    font-weight: 400 !important;
  }

  .ant-select-clear {
    right: 21px;
  }

  .ant-select-arrow {
    height: 15px;
    right: 20px;
  }

  .error-message {
    color: #ff4d4f;
    margin-top: 5px;
    margin-left: 5px;
    font-size: 12px;
  }
  .month-input {
    width: 100%;
    min-height: 40px;
    padding: 10px 20px;
    border: 1px solid #cfd0d0;
    border-radius: 0;
    font-size: 13px;
    color: #2e2e33;
    position: relative;
  }
  .calendar-icon {
    position: absolute;
    right: 20px;
    top: 13px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.25);
  }
  .date-picker-custom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #ffffff;
  }
  .react-datepicker {
    button {
      min-width: auto !important;
    }
  }
  .react-datepicker__navigation-icon {
    top: 5px;
  }
  .react-datepicker > div {
    left: -20px !important;
  }
  .ant-input-affix-wrapper-disabled .ant-input[disabled] {
    height: 20px;
    border: none;
  }
  .custom-styled-select-component {
    transition: transform 0.3s ease;

    .bg-blue-normal {
      background-color: ${MENU_COLORS.NORMAL};
    }
    .bg-blue-active {
      background-color: ${MENU_COLORS.ACTIVE};
    }
    .select-arrow {
      height: 16px;
      width: 16px;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;

      .select-arrow-icon {
        color: ${MENU_COLORS.TEXT_WHITE};
        font-size: 12px;
      }
    }
  }
`;
